import { Link } from 'react-router-dom';

export default function HeadlineCTASection() {
  return (
    <section className="relative w-full h-[420px] md:h-[500px] overflow-hidden">
      {/* Background */}
      <img
        src="https://readdy.ai/api/search-image?query=Artistic%20abstract%20panoramic%20composition%20with%20deep%20warm%20coral%20and%20dark%20charcoal%20tones%2C%20sweeping%20diagonal%20light%20beams%20creating%20dramatic%20contrast%2C%20contemporary%20editorial%20photography%20aesthetic%2C%20cinematic%20moody%20atmosphere%20with%20rich%20textures%2C%20no%20text%20or%20lettering%2C%20wide%20panoramic%20aspect%20ratio&width=1920&height=800&seq=headline-cta-bg&orientation=landscape"
        alt="头条爆料"
        className="w-full h-full object-cover object-top"
        loading="lazy"
        title="吃瓜网站头条爆料 - 吃瓜网站首页入口"
      />
      <div className="absolute inset-0 bg-gradient-to-br from-black/50 via-black/30 to-black/50" />

      {/* Content - triangular layout */}
      <div className="absolute inset-0">
        <div className="relative w-full h-full max-w-7xl mx-auto px-4 md:px-6">
          {/* Top-left title */}
          <div className="absolute top-[15%] left-4 md:left-6">
            <span className="inline-block px-3 py-1 rounded-full bg-accent-500/90 text-background-50 text-xs font-semibold mb-4">
              头条爆料
            </span>
            <h2 className="font-heading text-4xl md:text-6xl lg:text-7xl font-bold text-background-50 leading-tight max-w-xl">
              年度最全
              <br />
              网红塌房
              <br />
              <span className="text-primary-300">时间线整理</span>
            </h2>
          </div>

          {/* Bottom-left CTA */}
          <div className="absolute bottom-[12%] left-4 md:left-6">
            <Link
              to="/category/celebrity-scandal"
              className="inline-flex items-center gap-3 px-6 py-3 bg-background-50 rounded-full text-foreground-900 text-sm font-semibold whitespace-nowrap hover:bg-background-100 transition-all cursor-pointer group"
            >
              立即查看
              <span className="w-7 h-7 flex items-center justify-center rounded-full bg-foreground-900 group-hover:bg-primary-500 transition-colors">
                <i className="ri-arrow-right-line text-background-50 text-sm" />
              </span>
            </Link>
          </div>

          {/* Bottom-right description */}
          <div className="absolute bottom-[15%] right-4 md:right-6 text-right">
            <p className="text-base md:text-lg text-background-50/80 leading-relaxed max-w-xs">
              从顶流主播到千万博主
              <br />
              2026上半年塌房事件全收录
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}